import { Assert } from '@team/assert';
import { StringKit } from '@team/string';

export const hasInitials = (value?: string): value is string =>
  Assert.isString(value) && !StringKit.isEmpty(value);
